import ChevronRightIcon from "@artsy/icons/ChevronRightIcon"
import {
  Box,
  Button,
  Checkbox,
  Clickable,
  Flex,
  Join,
  Spacer,
  Text,
} from "@artsy/palette"
import { Formik } from "formik"
import { FC } from "react"

import { AlertNameInput } from "Components/Alert/Components/Form/AlertNameInput"
import { CriteriaPills } from "Components/Alert/Components/CriteriaPills"
import { DetailsInput } from "Components/SavedSearchAlert/Components/DetailsInput"
import { PriceRangeFilter } from "Components/Alert/Components/Form/PriceRange"
import { useAlertContext } from "Components/Alert/Hooks/useAlertContext"
import { useFeatureFlag } from "System/useFeatureFlag"

export interface AlertFormikValues {
  name: string
  push: boolean
  email: boolean
  details: string
}

export const Details: FC = () => {
  const { onComplete, dispatch, goToFilters, state } = useAlertContext()

  const newAlertModalFilteresEnabled = useFeatureFlag(
    "onyx_artwork_alert_modal_v2_filters"
  )

  return (
    <Formik<AlertFormikValues>
      initialValues={state.settings}
      onSubmit={onComplete}
    >
      {({ isSubmitting, values, setFieldValue, handleSubmit }) => {
        const transitionToFilters = () => {
          dispatch({ type: "SET_SETTINGS", payload: values })
          goToFilters()
        }

        return (
          <Flex flexDirection="column" p={2}>
            <Text variant="lg">Create Alert</Text>
            <Spacer y={2} />
            <AlertNameInput />
            <Spacer y={4} />
            <Join separator={<Spacer y={4} />}>
              <Box>
                <Text variant="sm-display" mb={1}>
                  Filters
                </Text>
                <Flex flexWrap="wrap" gap={1}>
                  <CriteriaPills />
                </Flex>
              </Box>

              {newAlertModalFilteresEnabled ? (
                <Clickable onClick={transitionToFilters} width="100%">
                  <Flex justifyContent="space-between" alignItems={"center"}>
                    <Box>
                      <Text variant="sm-display">Add Filters:</Text>

                      <Text variant="sm" color="black60">
                        Including Price Range, Rarity, Medium, Color
                      </Text>
                    </Box>

                    <ChevronRightIcon />
                  </Flex>
                </Clickable>
              ) : (
                <PriceRangeFilter expanded={false} />
              )}

              <DetailsInput />

              <Box>
                <Box display="flex" justifyContent="space-between">
                  <Text variant="sm-display">Email</Text>
                  <Checkbox
                    onSelect={selected => setFieldValue("email", selected)}
                    selected={values.email}
                  />
                </Box>

                <Spacer y={2} />

                <Box display="flex" justifyContent="space-between">
                  <Text variant="sm-display">Push Notifications</Text>
                  <Checkbox
                    onSelect={selected => setFieldValue("push", selected)}
                    selected={values.push}
                  />
                </Box>
              </Box>

              <Button
                loading={isSubmitting}
                onClick={() => {
                  dispatch({ type: "SET_SETTINGS", payload: values })
                  handleSubmit()
                }}
                width="100%"
              >
                Create Alert
              </Button>
            </Join>
          </Flex>
        )
      }}
    </Formik>
  )
}
